import React, { Fragment, useState, useEffect } from "react";
import {
  PaymentContainer,
  HyperLink,
  TopCenter,
} from "../../PaymentHistory/Styles";
import { TableWrapper } from "../index";
import _ from "lodash";
import queryString from "query-string";
import CustomTable from "./CustomTable";
import CaseService from "../../../../services/CaseService";
import moment from "moment";
import {
  getErrorMessage,
  getFileFormat,
  getFileName,
} from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import labels from "../../../../helpers/labels.json";
import {
  ButtonWrapper,
  AcceptButton,
  DeclineButton,
  Footer,
  ButtonContainer,
  DangerBtn,
  StatusBadge,
} from "../Styles";
import useLoader from "../../../../hooks/useLoader";
import Preview from "./Preview";
import { PrimaryCTAButton } from "../../../common/Buttons";
import useNotification from "../../../../hooks/useNotification";
import AlertDialog from "./AlertWrapper";
import theme from "../../../../assets/theme";
import { CommentSplitUp } from "./CommentSplitUp";
import GenerateNotice from "./GenerateNotice";
import { makeStyles, Tooltip } from "@material-ui/core";
import { StyledSelectFormControl } from "../../../common/CustomSelect/styles";
import NoticeService from "../../../../services/NoticeService";
import Axios from "axios";
import COLORS from "../../../../assets/Colors";
import UserSelect from "./UserSelect";

const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: COLORS.PRIMARY_WHITE,
    boxShadow: "none",
    width: "77px",
    height: "30px",
    color: COLORS.BTN_GREEN,
    textTransform: "Capitalize",
    border: "solid 1px #00838c",
    fontFamily: theme.fonts.primaryFontBold,
    fontSize: 14,
  },
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  table: {
    backgroundColor: "transparent",
    border: "1px solid #e1e3ee",
    borderRadius: 7,
    "& .MuiTableCell-root": {
      borderBottom: 0,
    },
  },
  tableHead: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: COLORS.INPUT_LABEL,
    fontSize: 12,
  },
  tableBody: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: COLORS.COLOR_DARK,
    fontSize: 12,
  },
  listbox: {
    color: "#293461",
    fontFamily: "openSans-SemiBold, sans-serif",
    fontSize: "14px",
    backgroundColor: "#ffffff",
    "& li[data-option-index]": {
      padding: "12px 16px !important",
      borderBottom: "1px solid #f3f4f6",
      transition: "all 0.2s ease",

      "&:hover": {
        backgroundColor: "#f0f9ff",
        paddingLeft: "20px !important",
      },
    },
  },
  noOptions: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: "#8294a5",
    padding: "16px",
    fontSize: "14px",
  },
  paper: {
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1) !important",
    borderRadius: "8px !important",
    border: "1px solid #e2e8f0 !important",
    width: "450px",
  },
}));

async function getMakerCheckerDetails(query = "") {
  try {
    const response = await CaseService.getMakerCheckerDetails(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const initFilters = [
  { label: "All", value: 0 },
  { label: "Pending", value: 0 },
  { label: "Approved", value: 0 },
  { label: "Rejected", value: 0 },
];

const filterByStatus = (selectedFilter) => {
  switch (selectedFilter) {
    case "Pending":
      return "notChecked";
    case "Approved":
      return "checked";
    case "Rejected":
      return "rejected";
    default:
      return ""; // All
  }
};

const NoticeAudit = ({ auditor, id, MTRef }) => {
  const [state, setState] = useState({});
  const [filters, setFilters] = useState(initFilters);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const placeholderText = "Search notice";
  const { enqueueSnackbar } = useSnackbar();
  const [modal, setModal] = useState({ state: false });
  const { setLoader } = useLoader();
  const [selectedId, setSelectedId] = useState([]);
  const [dialogData, setDialogData] = useState({});
  const { triggerNotify, setTriggerNotify } = useNotification();

  function setStats(total) {
    const checkStatusFilter = filterByStatus(selectedFilter);
    setFilters([
      { label: "All", value: checkStatusFilter === "" ? (total ?? 0) : 0 },
      {
        label: "Pending",
        value: checkStatusFilter === "notChecked" ? (total ?? 0) : 0,
      },
      {
        label: "Approved",
        value: checkStatusFilter === "checked" ? (total ?? 0) : 0,
      },
      {
        label: "Rejected",
        value: checkStatusFilter === "rejected" ? (total ?? 0) : 0,
      },
    ]);
  }
  const [open, setOpen] = useState(false);
  const [paperModal, setPaperModal] = useState({ state: false });
  const classes = useStyles();

  useEffect(() => {
    if (selectedFilter && MTRef?.current?.onQueryChange) {
      MTRef.current.onQueryChange({
        ...MTRef.current.state.query,
        page: 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter]);

  async function makerChekerUpdateStatus(
    reasonText,
    checkerId,
    id,
    status,
    ownerType,
    ownerId,
  ) {
    try {
      setLoader({ state: true, message: `split and upload...` });
      const payload = {
        id: [id],
        checkStatus: status,
        checkerId: parseInt(checkerId),
        filter: "bulkNoticeUpload",
        comments: reasonText,
        entityType: ownerType,
        entityId: ownerId,
      };
      const response = await CaseService.updateMakerChekerStatus(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  async function handleChecker(id, checkerId, role) {
    try {
      setLoader({ state: true, message: "Regenerate notice..." });
      let payload = {
        id: id,
        checkerId: parseInt(checkerId),
        ownerAssignedRole: role,
      };
      const response = await NoticeService.bulkNoticeGenerate(payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      const error = getErrorMessage(err);
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }
  // useEffect(() => {
  //   if (auditor) {
  //     MTRef.current.onQueryChange(MTRef?.current?.state?.query);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [auditor]);

  const fetchNotice = async (jobId) => {
    try {
      setLoader({ state: true, message: "fetching status..." });
      const response = await Axios.get(
        `https://staging-api.justact.co.in/get_notice/${jobId}`,
      );
      if (
        response?.data?.status === "failed" &&
        response?.data?.completed_rows === 0
      ) {
        enqueueSnackbar("Please use the correct coded template", {
          variant: "error",
        });
      } else if (
        response?.data?.completed_rows > 0 &&
        response?.data?.result_url
      ) {
        await NoticeService.updateNoticeOutput({
          jobId: jobId,
          // outputFile: response?.data?.clean_result_url,
          outputFile: response?.data?.result_url,
          // highlightOutputfile: response?.data?.result_url,
          // NAflag: response?.data?.na_flag,
        });
        MTRef.current.onQueryChange(MTRef?.current?.state?.query);
      } else if (response?.data?.status === "running") {
        enqueueSnackbar(`${response?.data?.progress}% completed`, {
          variant: "info",
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoader({ state: false });
    }
  };

  const columns = [
    {
      field: "id",
      title: "Id",
      sorting: false,
      render: (rowData) => <TopCenter>{rowData?.id}</TopCenter>,
      headerStyle: {
        width: 60,
      },
      cellStyle: {
        width: 80,
      },
    },
    {
      field: "name",
      title: "Maker Name",
      sorting: false,
      render: (rowData) => rowData?.makerDetails?.name,
    },
    {
      field: "name",
      title: "Checker Name",
      sorting: false,
      render: (rowData) => {
        // const canChangeChecker =
        //   auditor === "maker" &&
        //   rowData?.url &&
        //   !rowData?.checkerAcceptedAt &&
        //   !rowData?.noticeHighlightMetadata?.NAflag;
        const canChangeChecker =
          auditor === "maker" && rowData?.url && !rowData?.checkerAcceptedAt;

        if (canChangeChecker) {
          return (
            <StyledSelectFormControl
              style={{ width: "180px" }}
              className="mis-dashboard"
            >
              {/* <StyledAutocomplete
                classes={{
                  listbox: classes.listbox,
                  noOptions: classes.noOptions,
                  paper: classes.paper,
                }}
                options={menuItems.filter((item) => item.value !== id)}
                getOptionLabel={(option) => `${option.name} (${option.email})`}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(event, newValue) => {
                  if (!newValue) return;

                  const selectedRole = newValue.role || "agent";

                  setOpen(true);
                  setDialogData({
                    primaryBtnText: "Cancel",
                    secondaryBtnText: "Submit",
                    notTextArea: false,
                    clickSecondarybtn: () =>
                      handleChecker(rowData?.id, newValue.value, selectedRole),
                    clickPrimaryBtn: () => setOpen(false),
                    onDialogClose: () => setOpen(false),
                    desc: `Please note once you add the checker, you cannot change.`,
                    heading: "Are you sure you want to add this checker ?",
                    status: true,
                    descriptionTextStyle: {
                      textAlign: "left",
                      fontFamily: theme.fonts.primaryFontSemiBold,
                    },
                  });
                }}
                renderOption={(option) => (
                  <OptionContainer>
                    <OptionContent>
                      <OptionName>
                        {option.name}{" "}
                        <span style={{ fontSize: 11, color: "#888" }}>
                          ({option.role})
                        </span>
                      </OptionName>
                      <OptionEmail>{option.email}</OptionEmail>
                    </OptionContent>
                    <OptionCheck>✓</OptionCheck>
                  </OptionContainer>
                )}
                renderInput={(params) => (
                  <CustomInputField
                    {...params}
                    placeholder="Search checker"
                    size="small"
                    variant="outlined"
                  />
                )}
              */}
              <UserSelect
                classes={classes}
                partyId={rowData?.partyId}
                userId={id}
                selectedUser={rowData?.checkerDetails}
                onSelect={(user) => {
                  setOpen(true);
                  setDialogData({
                    primaryBtnText: "Cancel",
                    secondaryBtnText: "Submit",
                    notTextArea: false,
                    clickSecondarybtn: () =>
                      handleChecker(rowData?.id, user.value, user.role),
                    clickPrimaryBtn: () => setOpen(false),
                    onDialogClose: () => setOpen(false),
                    desc: `Please note once you add the checker, you cannot change.`,
                    heading: "Are you sure you want to add this checker ?",
                    status: true,
                  });
                }}
              />
            </StyledSelectFormControl>
          );
        }

        // if (rowData?.noticeHighlightMetadata?.NAflag) {
        //   return <TopCenter style={{ marginLeft: 15 }}>NA is captured in the notice.</TopCenter>;
        // }

        if (rowData?.checkerDetails?.name) {
          return rowData?.checkerDetails?.name;
        }

        return <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>;
      },
    },
    {
      field: "updated_at",
      title: labels["table.date"],
      sorting: false,
      render: (rowData) => (
        <>
          {moment(rowData?.updated_at, "YYYY-MM-DD HH:mm:ss")
            .add(5, "hours")
            .add(30, "minutes")
            .format("DD MMM YYYY, hh:mm A")}
        </>
      ),
      headerStyle: {
        width: 220,
      },
      cellStyle: {
        width: 230,
      },
    },
    {
      field: "id",
      title: "Preview",
      sorting: false,
      headerStyle: {
        textAlign: "left",
      },
      render: (rowData) => {
        // If status is approved (checked), show url (outputFile), otherwise show highlightOutputfile
        const previewFile =
          rowData?.checkStatus === "checked"
            ? rowData?.url
            : rowData?.noticeHighlightMetadata?.highlightOutputfile ||
              rowData?.url;

        return previewFile ? (
          <Tooltip title={getFileName(previewFile)} placement="right">
            <HyperLink
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                whiteSpace: "normal",
                overflow: "visible",
                display: "block",
              }}
              onClick={() =>
                setModal({
                  state: true,
                  url: previewFile,
                  format: getFileFormat(previewFile),
                  pdf: previewFile.toLowerCase().endsWith(".pdf"),
                  checkStatus: rowData?.checkStatus === "checked",
                })
              }
            >
              {getFileName(previewFile)}
            </HyperLink>
          </Tooltip>
        ) : (
          <Tooltip
            title={`${rowData?.lotNo} - ${rowData?.templateCode}`}
            placement="right"
          >
            <HyperLink
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                whiteSpace: "normal",
                overflow: "visible",
              }}
              onClick={() => fetchNotice(rowData?.id)}
            >
              {rowData?.lotNo} - {rowData?.templateCode}
            </HyperLink>
          </Tooltip>
        );
      },
    },
    {
      field: "checkStatus",
      title: "Status",
      sorting: false,
      render: (rowData) => {
        // if (rowData?.noticeHighlightMetadata?.NAflag) {
        //   return <StatusBadge status="N/A">N/A</StatusBadge>;
        // }
        if (rowData?.checkStatus === "checked") {
          return <StatusBadge status="Approved">Approved</StatusBadge>;
        }
        if (rowData?.checkStatus === "rejected") {
          return <StatusBadge status="Rejected">Rejected</StatusBadge>;
        }
        return <StatusBadge status="Pending">Pending</StatusBadge>;
      },
    },
    {
      field: "",
      title: "Re Generate",
      sorting: false,
      hidden: auditor === "maker" ? false : true,
      render: (rowData) =>
        rowData?.checkerDetails?.name ? (
          <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
        ) : rowData?.checkerId ? (
          <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
        ) : rowData?.url ? (
          <HyperLink>
            <TopCenter
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() =>
                setPaperModal({
                  state: true,
                  metaData: rowData?.regeneratePayload,
                })
              }
            >
              Re Generate
            </TopCenter>
          </HyperLink>
        ) : (
          <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
        ),
    },
    {
      field: "actions",
      title: "Actions",
      sorting: false,
      hidden: auditor === "maker" ? true : false,
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) =>
        rowData?.checkerAcceptedAt ? (
          <ButtonWrapper>
            <TopCenter>Completed</TopCenter>
          </ButtonWrapper>
        ) : (
          <ButtonWrapper>
            <AcceptButton
              onClick={() =>
                makerChekerUpdateStatus(
                  "",
                  rowData?.checkerId,
                  rowData?.id,
                  "checked",
                  rowData?.ownerType,
                  rowData?.ownerId,
                )
              }
            >
              <img
                src={require("../../../../assets/images/checkBoxSelected.svg")}
                alt="accept"
              />
            </AcceptButton>
            <DeclineButton
              onClick={() => {
                setOpen(true);
                setDialogData({
                  primaryBtnText: "Cancel",
                  secondaryBtnText: "Submit",
                  clickSecondarybtn: (reasonText) =>
                    makerChekerUpdateStatus(
                      reasonText,
                      rowData?.checkerId,
                      rowData?.id,
                      "rejected",
                      rowData?.ownerType,
                      rowData?.ownerId,
                    ),
                  clickPrimaryBtn: () => setOpen(false),
                  onDialogClose: () => setOpen(false),
                  desc: `Please note once you reject the notice, you cannot continue approve again.`,
                  heading: "Do you really want to Reject this notice?",
                  status: true,
                  descriptionTextStyle: {
                    textAlign: "left",
                    fontFamily: theme.fonts.primaryFontSemiBold,
                  },
                });
              }}
            >
              <img
                src={require("../../../../assets/images/closeButton.svg")}
                alt="decline"
              />
            </DeclineButton>
          </ButtonWrapper>
        ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.search) {
        params.search = query.search;
        params.partyName = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      const checkStatusFilter = filterByStatus(selectedFilter);
      if (checkStatusFilter) {
        params.checkStatus = checkStatusFilter;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `/${auditor}/${id}/bulkNoticeUpload?${queryString.stringify(
          params,
        )}`;
      }
      getMakerCheckerDetails(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
            setStats(result.total);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  useEffect(() => {
    if (triggerNotify) {
      if (auditor === "maker") {
        MTRef.current.onSearchChange("");
      } else {
        MTRef.current.onQueryChange(MTRef?.current?.state?.query);
      }
      setTriggerNotify(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerNotify]);

  async function handleCaseSelection(reasonText, status) {
    try {
      setLoader({ state: true, message: `split and upload...` });
      const payload = {
        id: selectedId,
        checkStatus: status,
        checkerId: parseInt(id),
        filter: "bulkNoticeUpload",
        comments: reasonText,
      };
      const response = await CaseService.updateMakerChekerStatus(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setSelectedId([]);
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  const detailPanel = [
    {
      tooltip: "View detailed split up...",
      render: (rowData) => {
        return <CommentSplitUp data={rowData} />;
      },
    },
  ];

  return (
    <Fragment>
      <PaymentContainer className="CreateCase" style={{ overflow: "hidden" }}>
        <TableWrapper style={{ marginTop: 20 }}>
          <CustomTable
            selection={auditor === "maker" ? false : true}
            onSelectionChange={(selected) =>
              setSelectedId(
                selected
                  .filter(
                    ({ checkerAcceptedAt, noticeHighlightMetadata }) =>
                      !checkerAcceptedAt && !noticeHighlightMetadata?.NAflag,
                  )
                  .map(({ id }) => id),
              )
            }
            hidePagination={state.lastPage === 1}
            pageSize={state?.data?.length ? state?.data?.length : 10}
            pluralTitle={"Notice"}
            singularTitle=""
            hideFilterBar={auditor === "maker"}
            {...{
              columns,
              data,
              placeholderText,
              MTRef,
              filters,
              selectedFilter,
              setSelectedFilter,
            }}
            detailPanel={auditor === "maker" ? detailPanel : ""}
            //noToolbar
            state={state}
          />
          {selectedId?.length ? (
            <Footer>
              <ButtonContainer>
                <div className="button-row">
                  <DangerBtn
                    style={{
                      width: "216px",
                      marginLeft: "26px",
                      marginTop: 20,
                    }}
                    onClick={() => {
                      setOpen(true);
                      setDialogData({
                        primaryBtnText: "Cancel",
                        secondaryBtnText: "Submit",
                        clickSecondarybtn: (reasonText) =>
                          handleCaseSelection(reasonText, "rejected"),
                        clickPrimaryBtn: () => setOpen(false),
                        onDialogClose: () => setOpen(false),
                        desc: `Please note once you reject the notice, you cannot continue approve again.`,
                        heading: "Do you really want to reject this notice?",
                        status: true,
                        descriptionTextStyle: {
                          textAlign: "left",
                          fontFamily: theme.fonts.primaryFontSemiBold,
                        },
                      });
                    }}
                  >
                    Reject
                  </DangerBtn>

                  <PrimaryCTAButton
                    style={{
                      width: "216px",
                      marginLeft: "26px",
                      marginTop: 20,
                    }}
                    onClick={() => handleCaseSelection("", "checked")}
                  >
                    Approve
                  </PrimaryCTAButton>
                </div>
              </ButtonContainer>
            </Footer>
          ) : null}
        </TableWrapper>
      </PaymentContainer>
      {modal?.state && <Preview {...{ modal, setModal }} />}
      {paperModal?.state && (
        <GenerateNotice {...{ paperModal, setPaperModal }} />
      )}
      <AlertDialog
        isOpen={open}
        {...{ ...dialogData }}
        descriptionTextStyle={{
          textAlign: "left",
          fontFamily: theme.fonts.primaryFontSemiBold,
        }}
      />
    </Fragment>
  );
};

export default NoticeAudit;
